// Pages/ViewBudgetMaster.jsx
import { useEffect, useState } from "react";
import { downloadAllAssetDataExcel } from "../../Api/AssetManagement";
import { Container, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { FaDownload } from "react-icons/fa";
import Logo from "../../Components/Logo";
import { useAssetContext } from '../../Context/MasterContext/AssetContext';

const AssetServiceList = () => {
    const { serviceAsset,
        loadAssetService } = useAssetContext();
    const [loading, setLoading] = useState(false);


    console.log(serviceAsset, 'serviceAsset')

    const downloadAsssetExcelData = async () => {
        setLoading(true); // Show loader
        try {
            const response = await downloadAllAssetDataExcel(); // Call the API
            if (!response.data) {
                throw new Error("No data received from server");
            }
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Asset_Data.xlsx');

            // Trigger download
            document.body.appendChild(link);
            link.click();

            // Cleanup
            setTimeout(() => {
                window.URL.revokeObjectURL(url);
                link.parentNode.removeChild(link);
            }, 100);

        } catch (error) {
            console.error("Error downloading data:", error);
        } finally {
            setLoading(false); // Hide loader after API call
        }
    }

    useEffect(() => {
        loadAssetService();
    }, []);

    return (
        <>
            <div className="main-content expand">
                <Container fluid className="list-container">
                    {loading && (
                        <div className="loading-overlay">
                            <Logo />
                        </div>
                    )}
                    <div className="page-headings">
                        <div className="heading-name">
                            <h2 className="list-title">Asset Service Lists</h2>
                        </div>
                        <div className="heading-options">
                            <button className="file-btn download-btn"
                                onClick={downloadAsssetExcelData}
                            >
                                <FaDownload className='file-icon' />
                            </button>
                        </div>
                    </div>

                    {serviceAsset.length > 0 ? (
                        <Table bordered hover responsive className="data-table">
                            <thead>
                                <tr>
                                    {/* <th>Ser.</th> */}
                                    <th>Service ID.</th>
                                    <th>Asset ID</th>
                                    <th>Service Date</th>
                                    <th>Service Type</th>
                                    <th>Service Prov.</th>
                                    <th>Contact Det.</th>
                                    <th>Service Cost</th>
                                    <th>Under AMC</th>
                                    <th>Next Service Due Date</th>
                                    <th>Remarks</th>
                                    <th>Created At</th>
                                    <th>Created By</th>
                                    <th>Updated At</th>
                                    <th>Updated By</th>
                                </tr>
                            </thead>
                            <tbody>
                                {serviceAsset.map((budget, index) => (
                                    <tr key={index}>
                                        {/* <td>{index + 1}</td> */}
                                        <td>{budget.service_ID}</td>

                                        <td>{budget.asset_ID}</td>
                                        <td>{budget.service_Date}</td>
                                        <td>{budget.service_Type}</td>


                                        <td>{budget.service_Provider}</td>

                                        <td>{budget.contact_Details}</td>
                                        <td>{budget.service_Cost}</td>
                                        <td>{budget.under_AMC}</td>
                                        <td>{budget.next_Service_Due_Date}</td>

                                        <td>{budget.remarks}</td>

                                        <td>{moment(budget.created_Date).format('L')} at {budget.created_Time}</td>
                                        <td>{budget.created_By}</td>

                                        <td>{moment(budget.last_Updated_Date).format('L')} at {budget.last_Updated_Time}</td>
                                        <td>{budget.last_Updated_By}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <p className="no-data">No Assets Data found.</p>
                    )}
                </Container>
            </div>
        </>
    );
};

export default AssetServiceList